import { useSelector, useDispatch } from 'react-redux';
import { getCustomer, getIsLoading, fetchCustomer } from './index';
import { useLayoutEffect } from 'react';

export const useCustomerInfoWithPrefetch = (isGuest = false) => {
    const dispatch = useDispatch();
    const customer = useSelector(getCustomer);
    const isLoading = useSelector(getIsLoading);

    useLayoutEffect(() => {
        if (!customer && !isLoading && !isGuest) {
            dispatch(fetchCustomer());
        }
    }, []);

    return customer;
};
